/**
 * @generated SignedSource<<e6c86929bd7f0464cca9ce25303bff7b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type waitForProductExists_checkProductExistsQuery$variables = {
  productId: string;
};
export type waitForProductExists_checkProductExistsQuery$data = {
  readonly existsProductOnDesignService: boolean;
  readonly existsProductOnInterfaceService: boolean;
};
export type waitForProductExists_checkProductExistsQuery = {
  response: waitForProductExists_checkProductExistsQuery$data;
  variables: waitForProductExists_checkProductExistsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "productId",
    "variableName": "productId"
  }
],
v2 = [
  {
    "alias": null,
    "args": (v1/*:: as any*/),
    "kind": "ScalarField",
    "name": "existsProductOnDesignService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*:: as any*/),
    "kind": "ScalarField",
    "name": "existsProductOnInterfaceService",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "waitForProductExists_checkProductExistsQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "waitForProductExists_checkProductExistsQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "1e50cdfa665ef97520f72b121571d64a",
    "id": null,
    "metadata": {},
    "name": "waitForProductExists_checkProductExistsQuery",
    "operationKind": "query",
    "text": "query waitForProductExists_checkProductExistsQuery(\n  $productId: String!\n) {\n  existsProductOnDesignService(productId: $productId)\n  existsProductOnInterfaceService(productId: $productId)\n}\n"
  }
};
})();

(node as any).hash = "9a19dbf24c07055b1ea465e5d5d61780";

export default node;
